import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Settings from "@/pages/Settings";
import ClientOnboarding from "@/pages/ClientOnboarding";
import ProjectTracker from "@/pages/ProjectTracker";
import Attendance from "@/pages/Attendance";
import Payroll from "@/pages/Payroll";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg-main)]">
        <div className="text-[var(--gold)] font-serif text-2xl tracking-widest animate-pulse">SAVIOR</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="settings" element={<Protected roles={["SuperAdmin", "SPV", "Leader"]}><Settings /></Protected>} />
              <Route path="clients" element={<ClientOnboarding />} />
              <Route path="tracker" element={<ProjectTracker />} />
              <Route path="attendance" element={<Attendance />} />
              <Route path="payroll" element={<Protected roles={["SuperAdmin", "SPV"]}><Payroll /></Protected>} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
